import React, { useMemo } from 'react';

import { CircularProgress, useTheme } from '@material-ui/core';

interface Props {
  loading: boolean;
  title: string;
  loaderVariant: 'primary' | 'paper';
  size?: number;
}

export const ButtonTitleWithLoading: React.FC<Props> = ({ loading, title, loaderVariant, size = 26.25 }) => {
  const theme = useTheme();

  const color = useMemo(() => {
    switch (loaderVariant) {
      case 'paper':
        return theme.palette.background.paper;
      case 'primary':
        return theme.palette.primary.main;
    }
  }, [loaderVariant]);

  return (
    <span
      style={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      {/* Title always stays in the layout so the button keeps its width — it's just hidden while loading. */}
      <span style={{ visibility: loading ? 'hidden' : 'visible' }}>{title}</span>
      {loading && (
        // Flex-centre the spinner via an overlay. Don't centre the CircularProgress itself with
        // `transform` — its indeterminate rotate animation overrides `transform` and pushes it off-centre.
        <span
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <CircularProgress size={size} style={{ color }} />
        </span>
      )}
    </span>
  );
};
